import { externalSupportStore } from "../stores/externalSupport.store";

export const useExternalSupportStore = () => externalSupportStore;
